import { render, staticRenderFns } from "./mortgage-loan-parts.vue?vue&type=template&id=74d31f5b"
import script from "./mortgage-loan-parts.vue?vue&type=script&lang=ts"
export * from "./mortgage-loan-parts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports